import { render } from "./AdministratoretMain.vue?vue&type=template&id=5b947996"
import script from "./AdministratoretMain.vue?vue&type=script&lang=js"
export * from "./AdministratoretMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__